var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FuzzyQuotePreviewDrawer',{attrs:{"visible":_vm.visible,"title":_vm.title},on:{"update:visible":function($event){_vm.visible=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }